import Layout from '@/layouts/Layout'

const underLease = {
  path: '/under_lease',
  component: Layout,
  name: 'under_lease',
  meta: {
    title: '租赁中',
  },
  children: [
    {
      path: '/underLease/groupDashboard/list',
      name: 'order_lease_data_board_tenant',
      component: () =>
        import('@/pages/orders/underLeaseDashboard/group/list/index.vue'),
      meta: { title: '租赁中看板', logEvent: '' },
    },
    {
      path: '/underLease/underLeaseOrder',
      name: 'under_lease_order',
      component: () => import('@/pages/orders/underLeaseOrder/list/index.vue'),
      meta: { title: '租赁中订单列表', logEvent: '' },
    },
    // 个人
    {
      path: '/underLease/underLeaseOrder/personalDetail',
      name: 'under_lease_order_rent_detail',
      hidden: true,
      component: () =>
        import('@/pages/orders/underLeaseOrder/detail/personalDetail/index.vue'),
      meta: { title: '租赁中订单详情', logEvent: '' },
    },
    {
      path: '/underLease/underLeaseOrder/terminateAgreement',
      name: 'under_lease_order_rent_terminate_agreement',
      hidden: true,
      component: () =>
        import('@/pages/orders/underLeaseOrder/detail/personalDetail'),
      meta: {
        title: '退车解约',
        logEvent: '',
        parent: {
          path: '/underLease/underLeaseOrder',
          name: 'under_lease_order',
          title: '租赁中订单列表',
        },
      },
    },
    // 企业(主)
    {
      path: '/underLease/underLeaseOrder/primaryOrderDetail',
      name: 'under_lease_order_ent_detail',
      hidden: true,
      component: () =>
        import('@/pages/orders/underLeaseOrder/detail/enterprisePrimaryDetail'),
      meta: { title: '企业主订单详情', logEvent: '' },
    },
    {
      path: '/underLease/underLeaseOrder/entAddCar',
      name: 'under_lease_order_ent_add_car',
      hidden: true,
      component: () =>
        import('@/pages/orders/underLeaseOrder/add/enterpriseAddOrder'),
      meta: {
        title: '新增租赁车辆',
        logEvent: '',
        parent: {
          path: '/underLease/underLeaseOrder',
          name: 'under_lease_order',
          title: '租赁中订单列表',
        },
      },
    },
    // 企业(子)
    {
      path: '/underLease/underLeaseOrder/enterpriseChildDetail',
      name: 'under_lease_order_ent_sub_detail',
      hidden: true,
      component: () =>
        import('@/pages/orders/underLeaseOrder/detail/personalDetail'),
      meta: { title: '租赁中订单详情', logEvent: '' },
    },
    {
      path: '/underLease/underLeaseOrder/enterpriseChildTerminateAgreement',
      name: 'under_lease_order_ent_sub_terminate_agreement',
      hidden: true,
      component: () =>
        import('@/pages/orders/underLeaseOrder/detail/personalDetail'),
      meta: {
        title: '退车解约',
        logEvent: '',
        parent: {
          path: '/underLease/underLeaseOrder',
          name: 'under_lease_order',
          title: '租赁中订单列表',
        },
      },
    },
    // ------------------------- 司机履约风控---------------------
    {
      path: '/underLease/riskControl/driverRiskControl',
      name: 'under_lease_driver_risk_control',
      component: () => import('@/pages/orders/riskControl/list/index.vue'),
      meta: { title: '司机履约风控', logEvent: '' },
    },
    {
      path: '/underLease/riskControl/riskDetail',
      name: 'under_lease_driver_risk_control_detail',
      hidden: true,
      component: () => import('@/pages/orders/riskControl/detail/index.vue'),
      meta: { title: '风控详情', logEvent: '' },
    },
    // --------------------------司机履约风控----end
    {
      path: '/underLease/overdue/summary',
      name: 'under_lease_over_due_sum',
      component: () => import('@/pages/orders/overdue/list/summary.vue'),
      meta: { title: '逾期汇总列表', logEvent: '' },
    },
    {
      path: '/underLease/overdue/detailList',
      name: 'under_lease_over_due_hasten_debt',
      component: () => import('@/pages/orders/overdue/list/detailList.vue'),
      meta: { title: '催租明细列表', logEvent: '' },
    },
    {
      path: '/underLease/overdue/detailList/detail',
      hidden: true,
      name: 'under_lease_over_due_hasten_debt_list_detail',
      component: () => import('@/pages/orders/overdue/detail/detailList'),
      meta: { title: '逾期单详情', logEvent: '' },
    },
    {
      path: '/underLease/withholdTermination/list',
      name: 'withhold_termination_list',
      component: () =>
        import(
          '@/pages/orders/underLeaseOrder/withholdTermination/list/index.vue'
        ),
      meta: { title: '支付宝解约列表', logEvent: '', keepAlive: false },
    },
    {
      path: '/underLease/complaintManage/list',
      name: 'complaint_manage_list',
      component: () => import('@/pages/orders/complaintManage/list/index.vue'),
      meta: { title: '司机申诉管理', logEvent: '', keepAlive: false },
    },
    {
      path: '/underLease/overdue/detailList/addCollection',
      hidden: true,
      name: 'under_lease_over_due_hasten_debt_remind_list_payment',
      component: () => import('@/pages/orders/overdue/add/addCollection'),
      meta: {
        title: '催租收款',
        logEvent: '',
        parent: {
          path: '/underLease/overdue/detailList',
          name: 'under_lease_over_due_hasten_debt',
          title: '催租明细列表',
        },
      },
    },
    // 个人订单收款详情
    {
      path: '/underLease/order/collection/detail',
      name: 'under_lease_order_rent_payment_detail',
      hidden: true,
      component: () => import('@/pages/orders/paymentDetail'),
      meta: { title: '订单收款详情', logEvent: '' },
    },
    // 企业租赁子订单收款详情
    {
      path: '/underLease/order/sub/collection/detail',
      name: 'under_lease_order_ent_sub_payment_detail',
      hidden: true,
      component: () => import('@/pages/orders/paymentDetail'),
      meta: { title: '订单收款详情', logEvent: '' },
    },
    // 租赁中个人租赁订单+企业租赁子订单共用一个页面
    {
      path: '/underLease/order/payment',
      name: 'under_lease_order_rent_offline_payment',
      component: () => import('@/pages/finance/AddCollection/index.vue'),
      meta: { title: '线下收款', logEvent: '' },
      hidden: true,
    },
    // 订单续约
    {
      path: '/underLease/orderRenewal/list',
      name: 'order_renewal',
      component: () => import('@/pages/orders/orderRenewal/list/index.vue'),
      meta: { title: '订单续约', logEvent: '' },
    },
    {
      path: '/underLease/orderRenewal/personalAdd',
      name: 'rent_order_renewal',
      component: () => import('@/pages/orders_new/orderRenewal/index.vue'),
      meta: {
        title: '个人订单续约',
        logEvent: '',
        parent: [
          {
            path: '/underLease/orderRenewal/list',
            name: 'order_renewal',
            title: '订单续约',
          },
          {
            path: '/workbench/rentOrder/list',
            name: 'workbench_rent_order',
            title: '个人租赁订单',
          },
        ],
        keepAlive: false,
      },
    },
    {
      path: '/underLease/orderRenewal/enterpriseAdd',
      name: 'ent_rent_order_renewal',
      component: () => import('@/pages/orders/orderRenewal/add/index.vue'),
      meta: {
        title: '企业订单续约',
        logEvent: '',
        parent: [
          {
            path: '/underLease/orderRenewal/list',
            name: 'order_renewal',
            title: '订单续约',
          },
          {
            path: '/workbench/entOrder/list',
            name: 'workbench_ent_rent_order',
            title: '企业租赁订单',
          },
        ],
      },
    },
    {
      path: '/underLease/orderRenewal/enterpriseSubBatchAdd',
      name: 'ent_rent_order_son_batch_renewal',
      component: () => import('@/pages/orders/orderRenewal/add'),
      meta: {
        title: '企业子订单批量续约',
        logEvent: '',
        parent: {
          path: '/underLease/orderRenewal/list',
          name: 'order_renewal',
          title: '订单续约',
        },
      },
    },
    {
      path: '/underLease/orderRenewal/enterpriseSubAdd',
      name: 'ent_rent_son_order_renewal',
      component: () => import('@/pages/orders/orderRenewal/add'),
      meta: {
        title: '企业子订单续约',
        logEvent: '',
        parent: {
          path: '/underLease/orderRenewal/list',
          name: 'order_renewal',
          title: '订单续约',
        },
      },
    },
  ],
}
export default underLease
